import React from "react";

const StatusMessage = () => {
  return (
    <div className="important">
      <span>
        <i className="far fa-bell fa-shake "></i> Important !
      </span>
    </div>
  );
};

export default StatusMessage;
